/**
 *
 * Asynchronously loads the component for Billing Page
 *
 */
import { lazyLoad } from 'utils/loadable';

export const Billing = lazyLoad(
  () => import('./index'),
  module => module.BillingPage,
);
